import { MODULES_PART1 } from './courseModules1to3';
import { MODULES_PART2 } from './courseModules4to5';
import { MODULES_PART3 } from './courseModules6to10';

export const COURSE = {
  title: 'SAP: Basics & Fundamentals',
  subtitle: '40 Hours • Beginner friendly • No SAP access required',
  totalHours: 40,
  provider: 'Steadfast IT Consulting',
  objectives: [
    'Understand what SAP is and how it supports businesses',
    'Learn key SAP modules and their business functions',
    'Understand end-to-end business processes in SAP',
    'Get familiar with SAP terminology, navigation concepts, and architecture',
    'Interpret SAP screens, reports, and workflows (via simulations)',
    'Be ready for entry-level SAP roles or further specialization',
  ],
  modules: [...MODULES_PART1, ...MODULES_PART2, ...MODULES_PART3],
};

// convenience lookups
export const getModule = (id) => COURSE.modules.find((m) => m.id === id);
export const getAllSubtopicIds = () =>
  COURSE.modules.flatMap((m) => m.subTopics.map((s) => s.id));
export const getSubtopicParent = (subId) =>
  COURSE.modules.find((m) => m.subTopics.some((s) => s.id === subId));
export const getSubtopic = (subId) => {
  for (const m of COURSE.modules) {
    const s = m.subTopics.find((x) => x.id === subId);
    if (s) return { module: m, sub: s };
  }
  return null;
};
